// Must stay the FIRST import in main.jsx: ES module imports are evaluated in
// order before main.jsx's own body runs, so this is the only way Sentry is
// live before App.jsx (and everything it pulls in) executes.
import { initSentry } from './lib/sentry'

initSentry()
